'use client';

import Icon from '@/components/ui/AppIcon';

const ContactMethods = () => {
  const contactMethods = [
    {
      icon: 'PhoneIcon',
      title: '24/7 Phone Support',
      detail: '020 4615 2876',
      description: 'Speak with UK-based travel advisors anytime',
      color: 'from-blue-500 to-cyan-500',
      action: { href: 'tel:02046152876', label: 'Call Now' },
    },
    {
      icon: 'EnvelopeIcon',
      title: 'Email Support',
      detail: 'info@dialforflight.co.uk',
      description: 'Response within 2 hours during business hours',
      color: 'from-purple-500 to-pink-500',
      action: { href: 'mailto:info@dialforflight.co.uk', label: 'Send Email' },
    },
    {
      icon: 'ChatBubbleLeftRightIcon',
      title: 'Live AI Chat',
      detail: 'Instant Responses',
      description: 'AI-powered chatbot available 24/7',
      color: 'from-emerald-500 to-teal-500',
      action: null,
    },
    {
      icon: 'DevicePhoneMobileIcon',
      title: 'WhatsApp',
      detail: '020 4615 2876',
      description: 'Quick inquiries via WhatsApp messaging',
      color: 'from-green-500 to-emerald-500',
      action: { href: 'https://wa.me/442046152876', label: 'Chat on WhatsApp' },
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-surface via-white to-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground mb-4">
            Multiple Ways to Reach Us
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Choose your preferred communication channel for immediate assistance
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contactMethods.map((method, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-brand-lg hover:shadow-3d transition-all duration-300 p-6 border-2 border-border hover:border-primary/30 transform hover:-translate-y-2 group"
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${method.color} rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={method.icon as any} size={28} className="text-white" />
              </div>
              
              <h3 className="font-heading text-xl font-black text-foreground mb-2">
                {method.title}
              </h3>
              
              <p className="text-primary font-bold mb-2">{method.detail}</p>
              
              <p className="text-sm text-muted-foreground mb-4">{method.description}</p>

              {method.action && (
                <a
                  href={method.action.href}
                  className={`inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-br ${method.color} text-white text-sm font-bold rounded-lg hover:scale-105 transition-all duration-200 shadow-md`}
                >
                  <Icon name={method.icon as any} size={14} className="text-white" />
                  {method.action.label}
                </a>
              )}
            </div>
          ))}
        </div>

        {/* Prominent Call Banner */}
        <div className="mt-12 bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white text-center shadow-3d">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <div>
              <h3 className="font-heading text-2xl font-black mb-1">Need Immediate Help?</h3>
              <p className="text-white/80">Our UK travel experts are available 24/7</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:02046152876"
                className="inline-flex items-center gap-3 px-8 py-4 bg-trust-green text-white font-heading font-black text-lg rounded-xl hover:bg-emerald-600 transition-all duration-300 hover:scale-105 shadow-lg"
              >
                <Icon name="PhoneIcon" size={24} className="text-white" />
                020 4615 2876
              </a>
              <a
                href="mailto:info@dialforflight.co.uk"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white/20 backdrop-blur-sm text-white font-heading font-black text-lg rounded-xl hover:bg-white/30 transition-all duration-300 hover:scale-105 border-2 border-white/30"
              >
                <Icon name="EnvelopeIcon" size={24} className="text-white" />
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;